import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import { Feed as FeedIcon } from '@mui/icons-material';

const FeedWidgetMobile = ({ onClick }) => {
  return (
    <Card 
      onClick={onClick}
      sx={{ 
        cursor: 'pointer',
        height: '100%',
        minHeight: 100,
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: 'white',
        boxShadow: 3,
        '&:active': {
          transform: 'scale(0.98)',
        },
        transition: 'transform 0.1s',
      }}
    >
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
          <FeedIcon sx={{ mr: 1, fontSize: 28 }} />
          <Typography variant="h6" fontWeight="bold">
            Internfeed
          </Typography>
        </Box>
        <Typography variant="body2" sx={{ opacity: 0.9 }}>
          Del oppdateringer med teamet
        </Typography>
      </CardContent>
    </Card>
  );
};

export default FeedWidgetMobile;
